import Skeleton from '@mui/material/Skeleton';
import { DataGridProps } from '@mui/x-data-grid';
import React from 'react';
import { DataGrid as DataGridStyled, GridContainer, InnerGrid } from './style';

export interface IRwDataGridProps extends DataGridProps {
    isLoading?: boolean;
    hideMargin?: boolean;
    pageSize?: number;
}

const DataGrid: React.FC<IRwDataGridProps> = props => {
    const { autoHeight, columns, pageSize, rowCount, rowHeight } = props;
    const { isLoading, hideMargin, ...rest } = props;

    if (isLoading || rowCount === null) {
        const loadingRows = Array.from({ length: pageSize || 0 }, (_, i) => ({ id: i }));

        const loadingColumn = () => (
            <div style={{ width: '70%' }}>
                <Skeleton variant='text' height={20} />
            </div>
        );

        const renderHeader = () => <Skeleton variant='text' width={80} height={30} />;

        const loadingColumns = columns.map(c => ({
            ...c,
            renderHeader: renderHeader,
            renderCell: loadingColumn
        }));

        return (
            <GridContainer hideMargin={hideMargin}>
                <InnerGrid>
                    <DataGridStyled
                        key='loading'
                        autoHeight={autoHeight}
                        columns={loadingColumns}
                        rows={loadingRows}
                        rowHeight={rowHeight ?? 52}
                        rowCount={pageSize}
                        hideFooter
                        disableColumnMenu
                        hideFooterSelectedRowCount
                    />
                </InnerGrid>
            </GridContainer>
        );
    }

    return (
        <GridContainer hideMargin={hideMargin}>
            <InnerGrid>
                <DataGridStyled key='loaded' {...rest} autoHeight disableColumnMenu hideFooterSelectedRowCount />
            </InnerGrid>
        </GridContainer>
    );
};

export default DataGrid;
